import { CostCentreItemComponentBase } from './cost-centre-item.component.base';
import { Component, ElementRef, Injector } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitService, CostCentreService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-cost-centre-item',
  templateUrl: './cost-centre-item.component.html',
  styleUrls: ['./cost-centre-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class CostCentreItemComponent extends CostCentreItemComponentBase {

  constructor(protected costCentreService: CostCentreService,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(costCentreService, businessUnitService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.businessUnitLoadSelectionList();
    this.typeLoadSelectionList();
  }

  itemSet() {
    super.itemSet();
  }

}





